(function(){
     'use strict';

     angular
        .module('app')
        .factory('UserService', UserService);

    UserService.$inject = ['$http'];

    function UserService($http){

        var service= {
           registrarCentro:registrarCentro,
           getCentroUser:getCentroUser,
           guardarCentro:guardarCentro,
           registrarUsuario:registrarUsuario,
           recuperarPass:recuperarPass,
           cambiarPass:cambiarPass
           
        };

        return service;
 		function registrarCentro(newCentro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               centro:newCentro,
               lang_id:lang_id
            });
            $http.post('/ajax/registrarcentro', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        function recuperarPass(datos,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               datos:datos,
               lang_id:lang_id
            });
            $http.post('/ajax/recuperarpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarPass(vm,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
                usuario:vm.recuperarDatos.mail,
               //newpass:vm.newpass,
               lang_id:lang_id
            });
            $http.post('/ajax/newpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        
        function registrarUsuario(registro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
               registro:registro,
               lang_id:lang_id
            });
            $http.post('/ajax/registrarusuario', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getCentroUser(callback)
        {

            var config = {headers : {}}

            return $http.get('/ajax/getcentrouser', {   
                params : { 
                }
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
           
        }

        function guardarCentro(info,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               info:JSON.stringify(info)
            });
            $http.post('/ajax/guardarcentro', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

       

    }
})();